(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/pix-item/assets/javascripts/pix-item.js') >= 0) return;  svs.modules.push('/components/tipsen/pix-item/assets/javascripts/pix-item.js');
"use strict";


const {
  useCallback,
  useEffect,
  useRef
} = React;
const {
  useBranding,
  useIsDrawPlayable
} = svs.components.tipsen.hooks;
const {
  usePlaceBet,
  hooks: {
    useDrawData,
    refreshPixAsync
  }
} = svs.components.sport.quickplayModal;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_LG
} = svs.components.lbUtils.useMediaQuery;
const {
  Shield
} = svs.components.lbUi.shield;
const {
  log
} = svs.core;
const logger = log.getLogger('tipsen:pixItem');
const {
  analytics
} = svs.components;
const {
  products
} = svs.utils;
const ROW_PRICE_TIPSEN = 1;
const FirstBannerText = () => React.createElement(React.Fragment, null, React.createElement("span", {
  className: "f-bold"
}, "PIX! "), React.createElement("span", {
  className: "f-normal"
}, "F\xE4rdiga spel."));
const SecondBannerText = () => React.createElement("span", {
  className: "f-normal"
}, "Helt enkelt.");
const BuyBannerText = _ref => {
  let {
    isWideDevice
  } = _ref;
  return React.createElement(React.Fragment, null, Boolean(isWideDevice) && React.createElement(React.Fragment, null, React.createElement(FirstBannerText, null), "\xA0", React.createElement(SecondBannerText, null)), Boolean(!isWideDevice) && React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement(FirstBannerText, null)), React.createElement("div", null, React.createElement(SecondBannerText, null))));
};
const PayButton = _ref2 => {
  var _svs$core$config$data;
  let {
    isDisabled,
    drawNumber,
    payButtonClassNames,
    productId,
    systemCost,
    wallet
  } = _ref2;
  const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
  const drawData = useDrawData({
    productId,
    drawNumber
  });
  const {
    placeBet,
    isPlaceBetInProgress
  } = usePlaceBet();
  const handleError = useCallback(error => {
    logger.info("usePixData() failed: \"".concat(error === null || error === void 0 ? void 0 : error.message, "\" (productId ").concat(productId, "), error code: ").concat(error === null || error === void 0 ? void 0 : error.code));
  }, [productId]);
  const handlePayButtonClick = useCallback(event => {
    if (!isDisabled || !isPlaceBetInProgress) {
      event.stopPropagation();
      refreshPixAsync({
        shouldIgnoreCache: false,
        productId,
        drawData,
        systemCost,
        setNormalizedData: pixData => {
          placeBet({
            drawData,
            pixData,
            wallet,
            rowPrice: ROW_PRICE_TIPSEN
          });
        },
        handleError,
        rowPrice: ROW_PRICE_TIPSEN
      });
    }
  }, [isDisabled, isPlaceBetInProgress, productId, drawData, systemCost, handleError, placeBet, wallet]);
  const handlePayButtonKeyDown = useCallback((event, key) => {
    event.stopPropagation();
    if ((key === null || key === void 0 ? void 0 : key.code) === 'Enter' || (key === null || key === void 0 ? void 0 : key.code) === 'Space') {
      handlePayButtonClick(event);
    }
  }, [handlePayButtonClick]);
  return React.createElement("button", {
    className: payButtonClassNames,
    "data-testid": "tipsen-pix-item-pay-button",
    disabled: isDisabled,
    onClick: handlePayButtonClick,
    onKeyDown: handlePayButtonKeyDown,
    type: "button"
  }, isSelfService ? 'Lägg i varukorg' : 'Köp');
};
const PixItem = _ref3 => {
  let {
    competitionId,
    displayQuickPlayModal,
    drawNumber,
    isCompetition,
    productId,
    systemCost,
    wallet,
    competitionType
  } = _ref3;
  const isWideDevice = useMediaQuery(breakpoints.up(BREAKPOINT_LG));
  const isDrawPlayable = useIsDrawPlayable(productId, drawNumber);
  const disablePixItem = !isDrawPlayable;
  const pixItemClassNames = ['pg_pix'];
  const showDetailsClassNames = ['pg_pix__buy_banner__details'];
  let drawCompetitionId = 0;
  if (isCompetition) {
    drawCompetitionId = competitionId;
  }
  const branding = useBranding(drawNumber, drawCompetitionId).join(' ');
  if (branding && branding.length > 0) {
    pixItemClassNames.push("pg_pix--".concat(branding));
  }
  if (disablePixItem) {
    pixItemClassNames.push('pg_pix--disabled');
    showDetailsClassNames.push('pg_pix__buy_banner__details--disabled');
  } else {
    pixItemClassNames.push('elevation-100', 'clickable-magnetic');
  }
  const handleClick = useCallback(() => {
    if (!disablePixItem) {
      const productName = products.getProductClassName(productId);
      analytics.trackEvent({
        category: 'Widget banner',
        action: 'Details',
        opt_label: "".concat(productName, "-").concat(systemCost)
      });
      displayQuickPlayModal(systemCost);
    }
  }, [disablePixItem, productId, systemCost, displayQuickPlayModal]);
  const handleKeyDown = useCallback(key => {
    if ((key === null || key === void 0 ? void 0 : key.code) === 'Enter' || (key === null || key === void 0 ? void 0 : key.code) === 'Space') {
      handleClick();
    }
  }, [handleClick]);
  const ref = useRef();
  useEffect(() => {
    const element = ref.current;
    element.addEventListener('tipsenOpenPixModal', handleClick);
    return () => element.removeEventListener('tipsenOpenPixModal', handleClick);
  }, [handleClick]);
  return React.createElement("div", {
    className: pixItemClassNames.join(' '),
    "data-pix-amount": systemCost,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: ref,
    role: "button"
  }, React.createElement("div", {
    className: "pg_pix__details_banner"
  }, React.createElement("div", {
    className: "pg_pix__details_banner__splash"
  }), isCompetition ? React.createElement(Shield, {
    className: "shield-pix shield-large pg_pix__details_banner__shield ".concat(competitionType === 'TipsEM' ? 'shield-green-white shield-green-white-pix' : ''),
    options: {
      hasLaurel: true
    }
  }, React.createElement("span", {
    className: "shield-unit pg_pix__details_banner__shield_unit"
  }, competitionType === 'TipsEM' ? 'Europa-mästaren' : 'Tips-SM 2024'), React.createElement("span", {
    className: "shield-value pg_pix__details_banner__shield_value"
  }, systemCost, ' ', "kr")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "pg_pix__details_banner__pix_size"
  }, systemCost, ' ', "kr"), React.createElement("div", {
    className: "pg_pix__details_banner__win_chances"
  }, systemCost, ' ', "chanser att vinna"))), React.createElement("div", {
    className: "pg_pix__buy_banner"
  }, React.createElement("div", {
    className: "pg_pix__buy_banner__text"
  }, React.createElement(BuyBannerText, {
    isWideDevice: isWideDevice
  })), React.createElement(PayButton, {
    drawNumber: drawNumber,
    isDisabled: disablePixItem,
    payButtonClassNames: "btn btn-default pg_pix__buy_banner__button ".concat(isCompetition ? "pg_pix__buy_banner__button--".concat(competitionType.toLowerCase()) : ''),
    productId: productId,
    systemCost: systemCost,
    wallet: wallet
  }), React.createElement("div", {
    className: showDetailsClassNames.join(' ')
  }, "Visa detaljer")));
};
setGlobal('svs.components.tipsen.pixItem.PixItem', PixItem);

 })(window);